import { Card, CardContent, Typography } from '@mui/material'
import React from 'react'
import { lightRed } from '../theme'

interface Props {
  amount: number | undefined
  order: string | undefined
  address: string | undefined
}

export const SterilizationDepositCard: React.FC<Props> = ({ amount, order, address }) => {
  return (
    <Card sx={{ backgroundColor: lightRed }}>
      <CardContent>
        <Typography sx={{ fontWeight: 700 }}>Caution de stérilisation</Typography>
        <Typography
          variant="body1"
          gutterBottom
          component="p"
          sx={{ fontSize: '14px', lineHeight: '17.2px', fontWeight: 400 }}
        >
          {amount && order && address
            ? `Dans le cadre de l’adoption, l’animal doit être stérilisé post adoption. Un chèque de caution d’un montant de 
        ${amount}€ à l’ordre de "${order}" devra être adressé à l’adresse : ${address}.`
            : `Dans le cadre de l’adoption, l’animal doit être stérilisé post adoption. Un chèque de caution devra être adressé à l’association, merci de vous rapprocher de votre interlocuteur.trice pour en connaitre les détails.`}
        </Typography>
      </CardContent>
    </Card>
  )
}
